export const environment = {
  production: true,
  wsurl: 'https://api.dacqsys.com',
  wspath: '/wss',
  wsport: 0,
};